
import React, { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { HomeLink } from '@/components/HomeLink';

interface LeaderboardEntry {
  id: string;
  user_id: string;
  wins: number;
  losses: number;
  total_points: number;
  display_name?: string;
  username?: string;
}

export const MultiplayerLeaderboard = () => {
  const [leaderboard, setLeaderboard] = useState<LeaderboardEntry[]>([]);

  useEffect(() => {
    fetchLeaderboard();
    const channel = supabase
      .channel('leaderboard_updates')
      .on('postgres_changes', { event: '*', schema: 'public', table: 'multiplayer_leaderboard' }, () => { fetchLeaderboard(); })
      .subscribe();

    return () => { supabase.removeChannel(channel); };
  }, []);

  const fetchLeaderboard = async () => {
    const { data, error } = await supabase
      .from('multiplayer_leaderboard')
      .select('*')
      .order('wins', { ascending: false })
      .limit(10);

    if (error || !data) return;

    const userIds = data.map(e => e.user_id);
    const { data: profiles } = userIds.length > 0
      ? await supabase.from('profiles').select('id, username, display_name').in('id', userIds)
      : { data: [] };

    const profileMap = new Map((profiles || []).map(p => [p.id, p]));

    setLeaderboard(data.map(e => ({
      ...e,
      display_name: profileMap.get(e.user_id)?.display_name || undefined,
      username: profileMap.get(e.user_id)?.username || undefined,
    })));
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <HomeLink />
      <h2 className="text-2xl font-bold text-gameGold mb-8">Multiplayer Leaderboard</h2>
      <div className="bg-gamePurple/30 rounded-lg overflow-hidden">
        <div className="grid grid-cols-4 gap-4 p-4 border-b border-gameGold/20 font-bold text-gameGold">
          <div>Player</div>
          <div>Wins</div>
          <div>Losses</div>
          <div>Points</div>
        </div>
        {leaderboard.map((entry) => (
          <div key={entry.id} className="grid grid-cols-4 gap-4 p-4 border-b border-gameGold/10">
            <div className="text-gameGold">{entry.display_name || entry.username || 'Unknown Player'}</div>
            <div className="text-green-500">{entry.wins}</div>
            <div className="text-red-500">{entry.losses}</div>
            <div className="text-gameGold">{entry.total_points}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
